"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveItemPriceOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var RemoveItemPriceOutputWidget = /** @class */ (function (_super) {
    __extends(RemoveItemPriceOutputWidget, _super);
    function RemoveItemPriceOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refundRequired = _this.props.interaction.factors.returnPremium > 0;
        return _this;
    }
    RemoveItemPriceOutputWidget.prototype.render = function () {
        var itemToProcess = JSON.parse(window.sessionStorage.getItem("itemToProcess"));
        if (this.refundRequired) {
            return (React.createElement("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center" },
                React.createElement("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2" }, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium)),
                React.createElement("div", null,
                    "will be refunded as a result of removing your ",
                    React.createElement("b", { className: "font-weight-semi-bold" },
                        " ",
                        itemToProcess.description))));
        }
        else {
            return (React.createElement("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center" },
                "There is no refund due as a result of removing your ",
                React.createElement("b", { className: "font-weight-semi-bold" },
                    " ",
                    itemToProcess.description)));
        }
    };
    return RemoveItemPriceOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.RemoveItemPriceOutputWidget = RemoveItemPriceOutputWidget;
//# sourceMappingURL=RemoveItemPriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/RemoveItemPriceOutputWidget.js
// module id = 2571
// module chunks = 0